import { render } from "./PopUpExoCalendar.vue?vue&type=template&id=656c4443"
import script from "./PopUpExoCalendar.vue?vue&type=script&lang=js"
export * from "./PopUpExoCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__